import Utility from '@/utils/Utility'

export default {
  name: "TypeRapidNotice",
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    showSoundFile() {
      return this.model.soundFile;
    },
    soundFile() {
      return this.model.soundFile;
    },
    title() {
      return this.model.title;
    },
    body() {
      return this.model.body;
    },
    showWebSites() {
      return this.model.webSites && this.model.webSites.length
    },
    webSites() {
      return this.model.webSites.map(item => {
        return '<a href="' + Utility.sanitizeUrl(item.url) + '" target="_blank">' + item.name + '</a>'
      }).join('<br />')
    },
    category() {
      return this.model.category;
    }
  }
};
